import { apiBaseUrl } from "shared/config/appConfig";

const PROGRAM_API_URL = `${apiBaseUrl}/programs`;

export const getProgram = async (programId, signal) => {
  const response = await fetch(`${PROGRAM_API_URL}/${programId}`, { signal });

  if (!response.ok) {
    throw new Error("Failed to load program");
  }

  return response.json();
};

export const createProgram = async (programDto) => {
  const response = await fetch(PROGRAM_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(programDto),
  });

  if (!response.ok) {
    throw new Error("Failed to save program");
  }

  return response.json();
};

export const updateProgram = async (programId, programDto) => {
  const response = await fetch(`${PROGRAM_API_URL}/${programId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(programDto),
  });

  if (!response.ok) {
    throw new Error("Failed to save program");
  }

  return response.json();
};

export const generateProgramPdf = async (programDto) => {
  const response = await fetch(`${PROGRAM_API_URL}/pdf`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(programDto),
  });

  if (!response.ok) {
    throw new Error("PDF generation failed");
  }

  const blob = await response.blob();
  const disposition = response.headers.get("content-disposition");
  let filename = "program.pdf";

  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = match[1];
    }
  }

  return { blob, filename };
};
